import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImageOff, Upload, X } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";
import { useImageSrc } from "@/components/OptionPhoto";

const LABEL = { exterior: "Exterior", interior: "Interior" };

export default function PlanePhoto({ aircraft, kind, onSaved }) {
  const api = useApi();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const photo = aircraft.photos?.[kind];
  const src = useImageSrc(photo?.url);
  const tid = `aircraft-${kind}-${aircraft.name}`;

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post(`/aircraft/${aircraft.id}/photos/${kind}`, fd);
      toast.success(`${aircraft.name} ${kind} photo saved`);
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm(`Remove the uploaded ${kind} photo for ${aircraft.name}?`)) return;
    try { await api.delete(`/aircraft/${aircraft.id}/photos/${kind}`); toast.success("Uploaded photo removed"); onSaved(); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="on-navy relative w-24 h-16 shrink-0 bg-[#0d0f14] border border-white/10 overflow-hidden group/pp" data-testid={tid}
      title={photo ? `${LABEL[kind]}: ${photo.source === "upload" ? "uploaded photo" : "from the PLANE LIST file"}` : `${LABEL[kind]}: category placeholder`}>
      {src ? <img src={src} alt={`${aircraft.name} ${kind}`} className="w-full h-full object-cover" loading="lazy" />
        : <div className="w-full h-full grid place-items-center text-[#C6A55C]"><ImageOff size={14} /></div>}
      <span className="absolute left-0 bottom-0 px-1 bg-black/70 text-[0.6rem] tracking-[0.1em] uppercase text-white" data-testid={`${tid}-source`}>
        {LABEL[kind]}{photo?.source === "upload" ? " · New" : ""}
      </span>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} data-testid={`${tid}-file-input`} />
      <div className="absolute top-1 right-1 flex gap-1 lg:inset-0 lg:items-center lg:justify-center lg:bg-black/55 lg:opacity-0 group-hover/pp:opacity-100 transition-opacity">
        <button type="button" onClick={() => input.current?.click()} disabled={busy} aria-label={`Upload ${kind} photo`}
          className="p-1 bg-black/70 border border-white/20 text-white hover:text-[#C6A55C] transition-colors" data-testid={`${tid}-upload-btn`}>
          {busy ? <span className="text-[0.55rem]">…</span> : <Upload size={12} />}
        </button>
        {photo?.source === "upload" && (
          <button type="button" onClick={remove} aria-label={`Remove uploaded ${kind} photo`}
            className="p-1 bg-black/70 border border-white/20 text-white hover:text-rose-300 transition-colors" data-testid={`${tid}-remove-btn`}>
            <X size={12} />
          </button>
        )}
      </div>
    </div>
  );
}
